import { createActions, createReducer } from 'reduxsauce';
import * as Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */
const tag = '[SAGA_ENQUIRY_REDUX]'; // eslint-disable-line

const functionDefinitions = {

    /*---------- getMyEnquiries --------*/
    requestGetMyEnquiries: ['userId', 'propertyId'],
    getMyEnquiriesSuccess: ['getMyEnquiriesResponse'],
    getMyEnquiriesFailure: ['getMyEnquiriesError'],

    /*---------- updateEnquiryStatus --------*/
    requestUpdateEnquiryStatus: ['enquiryId', 'status', 'userId', 'propertyId'],
    updateEnquiryStatusSuccess: ['updateEnquiryStatusResponse'],
    updateEnquiryStatusFailure: ['updateEnquiryStatusError'],

    /*---------- updateEnquirySource --------*/
    requestUpdateEnquirySource: ['enquiryId', 'source', 'userId', 'propertyId'],
    updateEnquirySourceSuccess: ['updateEnquirySourceResponse'],
    updateEnquirySourceFailure: ['updateEnquirySourceError'],

    /*---------- createEnquiryMemo --------*/
    requestCreateEnquiryMemo: ['enquiryId', 'status', 'memo', 'userId', 'propertyId'],
    createEnquiryMemoSuccess: ['createEnquiryMemoResponse'],
    createEnquiryMemoFailure: ['createEnquiryMemoError'],

    /*---------- getEnquiry --------*/
    requestGetEnquiry: ['userId'],
    getEnquirySuccess: ['getEnquiryResponse'],
    getEnquiryFailure: ['getEnquiryError'],

    /*---------- updateEnquiryBatch --------*/
    requestUpdateEnquiryBatch: ['updateEnquiryBatch'],
    updateEnquiryBatchSuccess: ['updateEnquiryBatchResponse'],
    updateEnquiryBatchFailure: ['updateEnquiryBatchError'],

    /*---------- exportEnquiryReport --------*/
    requestExportEnquiryReport: ['enquiryReportInput'],
    exportEnquiryReportSuccess: ['exportEnquiryReportResponse'],
    exportEnquiryReportFailure: ['exportEnquiryReportError'],

    /*---------- getEnquiryDetail --------*/
    requestGetEnquiryDetail: ['enquiryId'],
    getEnquiryDetailSuccess: ['getEnquiryDetailResponse'],
    getEnquiryDetailFailure: ['getEnquiryDetailError'],

    /*---------- updateEnquiryDetail --------*/
    requestUpdateEnquiryDetail: ['enquiryInfomation'],
    updateEnquiryDetailSuccess: ['updateEnquiryDetailResponse'],
    updateEnquiryDetailFailure: ['updateEnquiryDetailError'],

    /*---------- findMatchProperty --------*/
    requestFindMatchProperty: ['enquiryId'],
    findMatchPropertySuccess: ['findMatchPropertyResponse'],
    findMatchPropertyFailure: ['findMatchPropertyError'],

    /*---------- deleteEnquiry --------*/
    requestDeleteEnquiry: ['enquiryId'],
    deleteEnquirySuccess: ['deleteEnquiryResponse'],
    deleteEnquiryFailure: ['deleteEnquiryError'],

    /*---------- deleteEnquiries --------*/

    requestDeleteEnquiries: ['enquiryIds'],
    deleteEnquiriesSuccess: ['deleteEnquiriesResponse'],
    deleteEnquiriesFailure: ['deleteEnquiriesError'],
};

const { Types, Creators } = createActions(functionDefinitions);

export const SagaEnquiryTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const SagaEnquiryInitState = {};

export const INITIAL_STATE = Immutable(SagaEnquiryInitState);

/* ------------- Reducers ------------- */

/*---------- getMyEnquiries --------*/
export const requestGetMyEnquiries = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: true,
            userId: action.userId,
            propertyId: action.propertyId,
            getMyEnquiriesError: null,
        });
};
export const getMyEnquiriesSuccess = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            getMyEnquiriesResponse: action.getMyEnquiriesResponse,
        });
};
export const getMyEnquiriesFailure = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            getMyEnquiriesError: action.getMyEnquiriesError,
        });
};

/*---------- updateEnquiryStatus --------*/


export const requestUpdateEnquiryStatus = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: true,
            enquiryId: action.enquiryId,
            propertyId: action.propertyId,
            status: action.status,
            userId: action.userId,
            getMyEnquiriesError: null,
        });
};
export const updateEnquiryStatusSuccess = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            updateEnquiryStatusResponse: action.updateEnquiryStatusResponse,
        });
};
export const updateEnquiryStatusFailure = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            getMyEnquiriesError: action.getMyEnquiriesError,
        });
};

/*---------- updateEnquirySource --------*/


export const requestUpdateEnquirySource = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: true,
            enquiryId: action.enquiryId,
            propertyId: action.propertyId,
            source: action.source,
            userId: action.userId,
            getMyEnquiriesError: null,
        });
};
export const updateEnquirySourceSuccess = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            updateEnquirySourceResponse: action.updateEnquirySourceResponse,
        });
};
export const updateEnquirySourceFailure = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            getMyEnquiriesError: action.updateEnquirySourceError,
        });
};

/*---------- createEnquiryMemo --------*/
export const requestCreateEnquiryMemo = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: true,
            enquiryId: action.enquiryId,
            propertyId: action.propertyId,
            status: action.status,
            userId: action.userId,
            memo: action.memo,
            getMyEnquiriesError: null,
        });
};
export const createEnquiryMemoSuccess = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            createEnquiryMemoResponse: action.createEnquiryMemoResponse,
        });
};
export const createEnquiryMemoFailure = (state, action) => {
    return state.merge(
        {
            getMyEnquiriesFetching: false,
            createEnquiryMemoError: action.createEnquiryMemoError,
        });
};

/*---------- getEnquiry --------*/
export const requestGetEnquiry = (state, action) => {
    return state.merge(
        {
            getEnquiryFetching: true,
            userId: action.userId,
        });
};
export const getEnquirySuccess = (state, action) => {
    return state.merge(
        {
            getEnquiryFetching: false,
            getEnquiryResponse: action.getEnquiryResponse,
            getEnquiryError: null,
            exportEnquiryReportError: null
        });
};
export const getEnquiryFailure = (state, action) => {
    return state.merge(
        {
            getEnquiryFetching: false,
            getEnquiryError: action.getEnquiryError,
        });
};

/*---------- updateEnquiryBatch --------*/
export const requestUpdateEnquiryBatch = (state, action) => {
    return state.merge(
        {
            updateEnquiryBatchFetching: true,
            updateEnquiryBatch: action.updateEnquiryBatch,

        });
};
export const updateEnquiryBatchSuccess = (state, action) => {
    return state.merge(
        {
            updateEnquiryBatchFetching: false,
            updateEnquiryBatchResponse: action.updateEnquiryBatchResponse,
            getEnquiryResponse: action.updateEnquiryBatchResponse,
            updateEnquiryBatchError: false
        });
};
export const updateEnquiryBatchFailure = (state, action) => {
    return state.merge(
        {
            updateEnquiryBatchFetching: false,
            updateEnquiryBatchError: action.updateEnquiryBatchError,

        });
};


/*---------- exportEnquiryReport --------*/
export const requestExportEnquiryReport = (state, action) => {
    return state.merge(
        {
            exportEnquiryReportFetching: true,
            enquiryReportInput: action.enquiryReportInput,
            exportEnquiryReportError: null
        });
};
export const exportEnquiryReportSuccess = (state, action) => {
    return state.merge(
        {
            exportEnquiryReportFetching: false,
            exportEnquiryReportResponse: action.exportEnquiryReportResponse,
            exportEnquiryReportError: null
        });
};
export const exportEnquiryReportFailure = (state, action) => {
    return state.merge(
        {
            exportEnquiryReportFetching: false,
            exportEnquiryReportError: action.exportEnquiryReportError,

        });
};

/*---------- getEnquiryDetail --------*/
export const requestGetEnquiryDetail = (state, action) => {
    return state.merge(
        {
            getEnquiryDetailFetching: true,
            enquiryId: action.enquiryId,
            updateEnquiryDetailError: null,
            deleteEnquiryFetching: false,
            deleteEnquiryError: null,
        });
};
export const getEnquiryDetailSuccess = (state, action) => {
    return state.merge(
        {
            getEnquiryDetailFetching: false,
            getEnquiryDetailResponse: action.getEnquiryDetailResponse,
            getEnquiryDetailError: null
        });
};
export const getEnquiryDetailFailure = (state, action) => {
    return state.merge(
        {
            getEnquiryDetailFetching: false,
            getEnquiryDetailError: action.getEnquiryDetailError,

        });
};

/*---------- updateEnquiryDetail --------*/
export const requestUpdateEnquiryDetail = (state, action) => {
    return state.merge(
        {
            updateEnquiryDetailFetching: true,
            enquiryInfomation: action.enquiryInfomation,
        });
};
export const updateEnquiryDetailSuccess = (state, action) => {
    return state.merge(
        {
            updateEnquiryDetailFetching: false,
            updateEnquiryDetailResponse: action.updateEnquiryDetailResponse,
            updateEnquiryDetailError: null
        });
};
export const updateEnquiryDetailFailure = (state, action) => {
    return state.merge(
        {
            updateEnquiryDetailFetching: false,
            updateEnquiryDetailError: action.updateEnquiryDetailError,

        });
};

/*---------- findMatchProperty --------*/


export const requestFindMatchProperty = (state, action) => {
    return state.merge(
        {
            findMatchPropertyFetching: true,
            enquiryId: action.enquiryId,
            findMatchPropertyResponse: null,
            findMatchPropertyError: null,

        });
};
export const findMatchPropertySuccess = (state, action) => {
    return state.merge(
        {
            findMatchPropertyFetching: false,
            findMatchPropertyResponse: action.findMatchPropertyResponse,

        });
};
export const findMatchPropertyFailure = (state, action) => {
    return state.merge(
        {
            findMatchPropertyFetching: false,
            findMatchPropertyError: action.findMatchPropertyError,

        });
};

/*---------- deleteEnquiry --------*/
export const requestDeleteEnquiry = (state, action) => {
    return state.merge(
        {
            deleteEnquiryFetching: true,
            enquiryId: action.enquiryId,
            deleteEnquiryResponse: null,
            deleteEnquiryError: null,
        });
};
export const deleteEnquirySuccess = (state, action) => {
    return state.merge(
        {
            deleteEnquiryFetching: false,
            deleteEnquiryResponse: action.deleteEnquiryResponse,
        });
};
export const deleteEnquiryFailure = (state, action) => {
    return state.merge(
        {
            deleteEnquiryFetching: false,
            deleteEnquiryError: action.deleteEnquiryError,
        });
};


/*---------- deleteEnquiries --------*/
export const requestDeleteEnquiries = (state, action) => {
    return state.merge(
        {
            deleteEnquiriesFetching: true,
            enquiryIds: action.enquiryIds,
            deleteEnquiriesResponse: null,
            deleteEnquiriesError: null
        });
};
export const deleteEnquiriesSuccess = (state, action) => {
    return state.merge(
        {
            deleteEnquiriesFetching: false,
            deleteEnquiriesResponse: action.deleteEnquiriesResponse,
            getEnquiryResponse: action.deleteEnquiriesResponse,

        });
};
export const deleteEnquiriesFailure = (state, action) => {
    return state.merge(
        {
            deleteEnquiriesFetching: false,
            deleteEnquiriesError: action.deleteEnquiriesError,

        });
};


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {

    /*---------- getMyEnquiries --------*/
    [Types.REQUEST_GET_MY_ENQUIRIES]: requestGetMyEnquiries,
    [Types.GET_MY_ENQUIRIES_SUCCESS]: getMyEnquiriesSuccess,
    [Types.GET_MY_ENQUIRIES_FAILURE]: getMyEnquiriesFailure,

    /*---------- updateEnquiryStatus --------*/
    [Types.REQUEST_UPDATE_ENQUIRY_STATUS]: requestUpdateEnquiryStatus,
    [Types.UPDATE_ENQUIRY_STATUS_SUCCESS]: updateEnquiryStatusSuccess,
    [Types.UPDATE_ENQUIRY_STATUS_FAILURE]: updateEnquiryStatusFailure,

    /*---------- updateEnquirySource --------*/
    [Types.REQUEST_UPDATE_ENQUIRY_SOURCE]: requestUpdateEnquirySource,
    [Types.UPDATE_ENQUIRY_SOURCE_SUCCESS]: updateEnquirySourceSuccess,
    [Types.UPDATE_ENQUIRY_SOURCE_FAILURE]: updateEnquirySourceFailure,

    /*---------- createEnquiryMemo --------*/
    [Types.REQUEST_CREATE_ENQUIRY_MEMO]: requestCreateEnquiryMemo,
    [Types.CREATE_ENQUIRY_MEMO_SUCCESS]: createEnquiryMemoSuccess,
    [Types.CREATE_ENQUIRY_MEMO_FAILURE]: createEnquiryMemoFailure,

    /*---------- getEnquiry --------*/
    [Types.REQUEST_GET_ENQUIRY]: requestGetEnquiry,
    [Types.GET_ENQUIRY_SUCCESS]: getEnquirySuccess,
    [Types.GET_ENQUIRY_FAILURE]: getEnquiryFailure,

    /*---------- updateEnquiryBatch --------*/
    [Types.REQUEST_UPDATE_ENQUIRY_BATCH]: requestUpdateEnquiryBatch,
    [Types.UPDATE_ENQUIRY_BATCH_SUCCESS]: updateEnquiryBatchSuccess,
    [Types.UPDATE_ENQUIRY_BATCH_FAILURE]: updateEnquiryBatchFailure,

    /*---------- exportEnquiryReport --------*/
    [Types.REQUEST_EXPORT_ENQUIRY_REPORT]: requestExportEnquiryReport,
    [Types.EXPORT_ENQUIRY_REPORT_SUCCESS]: exportEnquiryReportSuccess,
    [Types.EXPORT_ENQUIRY_REPORT_FAILURE]: exportEnquiryReportFailure,

    /*---------- getEnquiryDetail --------*/
    [Types.REQUEST_GET_ENQUIRY_DETAIL]: requestGetEnquiryDetail,
    [Types.GET_ENQUIRY_DETAIL_SUCCESS]: getEnquiryDetailSuccess,
    [Types.GET_ENQUIRY_DETAIL_FAILURE]: getEnquiryDetailFailure,

    /*---------- updateEnquiryDetail --------*/
    [Types.REQUEST_UPDATE_ENQUIRY_DETAIL]: requestUpdateEnquiryDetail,
    [Types.UPDATE_ENQUIRY_DETAIL_SUCCESS]: updateEnquiryDetailSuccess,
    [Types.UPDATE_ENQUIRY_DETAIL_FAILURE]: updateEnquiryDetailFailure,

    /*---------- findMatchProperty --------*/
    [Types.REQUEST_FIND_MATCH_PROPERTY]: requestFindMatchProperty,
    [Types.FIND_MATCH_PROPERTY_SUCCESS]: findMatchPropertySuccess,
    [Types.FIND_MATCH_PROPERTY_FAILURE]: findMatchPropertyFailure,

    /*---------- deleteEnquiry --------*/
    [Types.REQUEST_DELETE_ENQUIRY]: requestDeleteEnquiry,
    [Types.DELETE_ENQUIRY_SUCCESS]: deleteEnquirySuccess,
    [Types.DELETE_ENQUIRY_FAILURE]: deleteEnquiryFailure,

    /*---------- deleteEnquiries --------*/

    [Types.REQUEST_DELETE_ENQUIRIES]: requestDeleteEnquiries,
    [Types.DELETE_ENQUIRIES_SUCCESS]: deleteEnquiriesSuccess,
    [Types.DELETE_ENQUIRIES_FAILURE]: deleteEnquiriesFailure,

});



// WEBPACK FOOTER //
// ./src/redux/sagaEnquiry/sagaEnquiryRedux.ts